import { b as border } from '../base/border-CeA6yfR3.js';
import { p as palette } from '../base/color-DMp1DFwP.js';
import { s as spacing } from '../base/spacing-zNVNrnl_.js';

/* eslint-disable id-length */
const checkboxStyles = {
  bg: palette.white,
  bgChecked: palette.blue[700],
  bgCheckedHover: palette.blue[800],
  bgDisabled: palette.gray[100],
  bgHover: palette.blue[200],
  bgActive: palette.blue[900],
  borderWidth: '1px',
  borderColor: palette.gray[500],
  borderColorDisabled: palette.gray[300],
  check: 'fas fa - check',
  // checked icon
  colorDisabled: palette.gray[700],
  radius: '3px',
  size: {
    medium: spacing.base,
    large: '20px'
  }
};
const mobileCheckboxStyles = {
  mobile: {
    padding: '10px 0',
    groupBackgroundColor: palette.white,
    groupBorderColor: palette.mercury,
    groupBorderRadius: border.roundedThin.radius,
    groupBorderWidth: border.roundedThin.width
  }
};

export { checkboxStyles as c, mobileCheckboxStyles as m };
//# sourceMappingURL=checkbox-9mCPwUIz.js.map
